import { useTranslation } from "react-i18next"
import PageLayout from "components/layout/PageLayout"
import { useLocation, useNavigate } from "react-router-dom"
import CostRefundForm from "./views/CostRefundForm"
import { useState } from "react"
import { useUpdateMyCostRefundMutation } from "./api/costRefundApiSlice"


const CostRefundEdit = () => {

    let location = useLocation()
    let navigate = useNavigate();
    let refund = location.state.costRefund
    const [t, i18n] = useTranslation(["global", "absenceReport"])
    const [formData, setFormData] = useState(mapFromDtoToForm(refund))

    const [
        sendRequest, {
            isLoading: sendingIsLoading,
            isSuccess: sendingIsSuccess }
    ] = useUpdateMyCostRefundMutation()


    function mapFromDtoToForm(refundDto) {
        let refundData = { ...refundDto }
        refundData.dateRange = [new Date(refundDto.startDate * 1000), new Date(refundDto.endDate * 1000)]
        refundData.expenseItems = refundDto.expenseItems.map((item, index) => {
            return { ...item, id: index + 1 }
        })
        refundData.existingAttachments = refundDto.attachments || []
        refundData.errors = []
        return refundData
    }

    function handleCorrectionSave() {
        const [startDate, endDate] = formData.dateRange
        const startEpoch = (new Date(startDate).getTime()) / 1000
        const endEpoch = (new Date(endDate).getTime()) / 1000


        const requestPayload = new FormData();
        requestPayload.append("costRefundRequestDto", new Blob([JSON.stringify({
            guid: refund.guid,
            title: formData.title,
            isKmMode: formData.isKmMode,
            isAnalyticMode: formData.isAnalyticMode,
            isForfaitMode: formData.isForfaitMode,
            distance: formData.isKmMode ? formData.distance : 0,
            expenseItems: formData.expenseItems,
            startDateTime: startEpoch,
            endDateTime: endEpoch,
            notes: formData.notes,
            existingAttachments: formData.existingAttachments || [],
        })], { type: 'application/json' }));

        if (formData.newAttachments && formData.newAttachments.length > 0) {
            formData.newAttachments.forEach((file) => {
                requestPayload.append("attachments", file);
            });
        }

        // Invio della richiesta
        sendRequest(requestPayload);
    }

    if (sendingIsSuccess) {
        navigate("/dashboard/costRefunds/my");
    }

    let content = (
        <div className="row">

            <div className="col-md-8">
                <div className="card bg-dark">
                    <div className="card-body ">
                        <CostRefundForm
                            formData={formData}
                            onFormChange={(data) => {
                                console.log("FormData:" + JSON.stringify(data))
                                setFormData(data)
                            }}
                        />
                    </div>
                </div>
            </div>
            <div className="col-md-4">
                <div className="card bg-warning bg-opacity-25">
                    <div className="card-body  ">
                        <h5 className="card-title"><i className="fa-solid fa-triangle-exclamation"></i> {t("absenceReport:label.reason")}</h5>
                        <p className="card-text">"{refund.reason}"</p>
                        <a onClick={handleCorrectionSave} className="btn btn-primary">{t("absenceReport:action.confirm_adjustment")}</a>
                    </div>
                </div>
            </div>
        </div>
    )

    return <PageLayout
        pageTitle={"Modifica Nota Spesa"}
        bodyContent={content}
        isLoadingContent={sendingIsLoading}

    />
}

export default CostRefundEdit